export const CRYPTO_KEY = 'mnWfWE2RDJTMIq77JB4GMg=='
